const cleanObject = (payload) => {
  const obj = {};
  Object.keys(payload).forEach((key) => {
    if (payload[key]) {
      obj[key] = payload[key];
    }
  });
  return obj;
};

export default cleanObject;
